import React, { Component } from 'react';
import Spinner from './Spinner';
import TinySpinner from './TinySpinner';

import u from './Utilities';

class TextFill extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    renderIcon() {
        if(this.props.spinner) {
            return (
                <Spinner/>
            )
        }
        return (
            <i className={this.props.iconClass ?? 'fas fa-info'}></i>
        )
    }
    
    render() { 
        return (
            <div className={u.autoclass({
                "hw-widget__text-fill": true,
                "hw-widget__text-fill--small": this.props.small
            })}>
                {this.renderIcon()}
                <p>{this.props.children}</p>
            </div>
        );
    }
}
 
export default TextFill;